import { DecimalPipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ENGLISH_LANGUAGE_CODE } from '@nk/localization-lib';
import { AccountNumberDenomination, DEFAULT_ACCOUNTS_NUMBER_DENOMINATION } from '../utils/company-accounts.utils';

@Pipe({
  standalone: true,
  name: 'accountsNumber',
})
@Injectable({
  providedIn: 'root',
})
export class AccountsNumberPipe implements PipeTransform {
  private _decimalPipe = new DecimalPipe(ENGLISH_LANGUAGE_CODE);

  public transform(
    value: number | string,
    accountsNumberDenomination: AccountNumberDenomination = DEFAULT_ACCOUNTS_NUMBER_DENOMINATION.data,
  ): string {
    if (typeof value === 'string') {
      return value;
    }

    if (value == null || isNaN(value)) {
      return ''; // Handles null, undefined, and NaN.
    }

    value = Math.floor(Math.round(value / accountsNumberDenomination));

    if (value === 0) {
      return '0';
    }

    const thousandQuotes = "'".repeat((Math.log10(accountsNumberDenomination) + 2) / 3);

    const transformedValue = this._decimalPipe.transform(value);
    const serializedNumber = transformedValue ? transformedValue.replace(/[,.]/g, ' ') + thousandQuotes : '';

    return value < 0 ? `(\u00A0${serializedNumber}\u00A0)`.replace(/-/g, '') : serializedNumber;
  }
}
